import { filter, groupBy, hasKey, map } from 'fun-util';

const getPopupIdsOnPage = popups => map(
  groupBy(
    filter(popups, popup => hasKey(popup, 'pageIdx')),
    popup => popup.pageIdx,
  ),
  Object.keys,
);

export default getPopupIdsOnPage;



// WEBPACK FOOTER //
// ./src-react/Popups/helpers/getPopupIdsOnPage.jsx